module.exports = __webpack_public_path__ + "img/icon_map_5_c.88c6a34f.png";